import Vue from 'vue'
import VueRouter from 'vue-router'
import Account from './panels/Account.vue'
import ScoreList from './panels/ScoreList.vue'
import TowerList from './panels/TowerList.vue'
import CommentList from '@/pages/user/components/CommentList.vue'
import Follow from './panels/Follow.vue'
import Follower from './components/Follower.vue'
import Followee from './components/Followee.vue'
import ListManager from './panels/ListManager.vue'
import Storage from './panels/Storage.vue'

Vue.use(VueRouter)

export const pages = [
    {
        path: '/account',
        name: 'account',
        component: Account,
        meta: {
            title: "账号",
            icon: "user",
        }
    },
    {
        path: '/score/:page?',
        name: 'score',
        component: ScoreList,
        meta: {
            title: "提交",
            icon: "history",
            hasPage: true,
        },
    },
    {
        path: '/tower/:page?',
        name: 'tower',
        component: TowerList,
        meta: {
            title: "作品",
            icon: "file",
            hasPage: true,
        },
    },
    {
        path: '/comment/:page?',
        name: 'comment',
        component: CommentList,
        meta: {
            title: "发言",
            icon: "message",
            hasPage: true,
        },
    },
    {
        path: '/follow',
        name: 'follow',
        redirect: '/followee',
        component: Follow,
        meta: {
            title: "关注",
            icon: "heart",
        },
        children: [
            {
                path: '/followee/:page?',
                name: 'followee',
                component: Followee,
                meta: {
                    title: "关注的人",
                    hasPage: true,
                },
            },
            {
                path: '/follower/:page?',
                name: 'follower',
                component: Follower,
                meta: {
                    title: "关注我的人",
                    hasPage: true,
                },
            },
            {
                path: '/focusTower/:page?',
                name: 'focusTower',
                meta: {
                    title: "关注的塔",
                    hasPage: true,
                },
            },
        ].map(e => {
            e.meta.key = "follow";
            return e;
        })
    },
    {
        path: '/listManager',
        name: 'listManager',
        component: ListManager,
        meta: {
            title: "列表",
            icon: "unordered-list",
        },
    },
    {
        path: '/storage',
        name: 'storage',
        component: Storage,
        meta: {
            title: "存档",
            icon: "save",
        },
    },
]

const routes = [
    {
        path: '/',
        redirect: '/account',
    }, ...pages.map(e => {
        e.meta.key = e.name;
        return e;
    })
];

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.meta.hasPage) {
        if (!to.params.page) to.params.page = 1;
    }
    next();
})

export default router
